import { afMenus, WPAPIEndpoint } from '@/globalVariables';
import { afLength } from '../helpers';

const afGetNavMenu: () => Promise<Record<string, any>> = async (): Promise<Record<string, any>> => {
    if ( afLength( afMenus ) ) {
        return afMenus;
    } else {
        try {
            const menusAllEndpoint: string = `${WPAPIEndpoint}/menu/`;
            if ( afEnv !== 'prod' ) {
                console.log( 'afGetNavMenu ' + menusAllEndpoint );
            }
            const response: Response = await fetch( menusAllEndpoint );
            if ( ! response.ok ) {
                throw new Error( `HTTP error! Status: ${response.status}` );
            }
            const data: Record<string, any> = await response.json();
            for ( let menuLocation in data ) {
                afMenus[ menuLocation ] = data[ menuLocation ];
            }
            return afMenus;
        } catch ( error ) {
            console.log( 'Error fetching nav menus: ' + error );
            throw error;
        }
    }
}
export default afGetNavMenu;